// tslint:disable
/**
 * Dhimahi Webshop Online Ticket API
 * Version 1.0.0, provides API end points for front-end
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: team.dws.jira@dhimahi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
* 
* @export
* @enum {string}
*/
export enum ApiEndpoint {
    apiSharedTicketsGet = '/api/shared-tickets',
    apiSharedTicketsTokenGet = '/api/shared-tickets/token',
    createOnlineTicketShare = '/api/shared-tickets',
    revokeOnlineTicketShare = '/api/shared-tickets/{ticketId}'
}
